<template>
    <div>
        <myPage>
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">签约时间{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.vendor_cname">
                        <span slot="prepend">{{$t('cname')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.mac_id">
                        <span slot="prepend">商户号{{$t('x_dd')}}</span>
                    </el-input>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list(false)">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh flex-box nopadding">
                <div class="width-300 round-top10 flex-box col fillh mg-right5 border-table">
                    <div class="pd-5 bg-table-head border-bottom-line-has f-bd">可签约供应商</div>
                    <div class="flex-box-bd tleft" style="overflow-y: auto" v-if="un_vendors.length > 0">
                        <div class="flex-box border-bottom-line" v-for="(item,index) in un_vendors" :key="item.vendor_id">
                            <div class="flex-box-bd tleft">{{item.vendor_cname}}</div>
                            <div class="mg-left10">
                                <a class="link" @click="openAdd('add', item.vendor_id)">签约</a>
                            </div>
                        </div>
                    </div>
                    <div class="mg-top30" v-else>
                        <myNodata></myNodata>
                    </div>
                </div>
                <div class="flex-box-bd fillh">
                    <el-table :data="listData" class="el-table--border" height="100%">
                        <el-table-column prop="vendor_cname" :label="listHeader.vendor_cname" min-width="200px"></el-table-column>
                        <el-table-column :label="listHeader.mac_id" width="300px">
                            <template slot-scope="scope">
                                <div>{{scope.row.mac_id_nick}}：{{scope.row.mac_id}}</div>
                                <div>{{scope.row.api_key_nick}}：{{scope.row.api_key}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column :label="listHeader.bal_amt" min-width="120px">
                            <template slot-scope="scope">
                                <span>{{scope.row.bal_amt == ''?'***':scope.row.bal_amt}}</span>
                                <a class="link mg-left5" v-if="scope.row.bal_amt == ''" @click="getBalAmt(scope.row)">显示</a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="add_time" :label="listHeader.add_time" width="150px"></el-table-column>
                        <el-table-column fixed="right" width="60px">
                            <template slot-scope="scope">
                                <a class="link" @click="openSave('upd', scope.row.org_vendor_id)">{{$t('info')}}</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    import myPager from '../../../components/myPager'
    import myNodata from '../../../components/myNodata'
    import myDatePicker from '../../../components/myDatePicker'
    import request from "../../../utils/request_api";
    export default {
        name:'base-orgvendor',
        components:{
            myPager,
            myNodata,
            myDatePicker
        },
        data:function(){
            const listHeader = {
                vendor_cname: '已签约',
                mac_id: '签约信息',
                api_key: '秘钥',
                bal_amt: '余额',
                add_time: '签约时间',
            };
            return{
                self:this,
                show_subview:false,
                relist:false,
                search:{
                    search_url: "org-vendor/list",
                    datearea_id:0,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0,
                    vendor_cname: "",
                    mac_id: ""
                },
                listHeader,//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                },
                un_vendors:[]
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.$base.listPageInit(this,()=>{
                this.getUnVendor();
                this.list();
            });
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            getUnVendor: function(){
                this.$base.showLoading();
                this.$request.sendPost("org-vendor/get-un-vendor", {},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.un_vendors = data.un_vendors;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            getBalAmt: function(item) {
                var data = {
                    vendor_id: item.vendor_id
                };
                this.$base.showLoading();
                this.$request.sendPost("org-vendor/get-bal-amt",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        item.bal_amt = data.bal_amt;
                        this.$base.msgSuccess();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            list: function (change_page) {
                this.$base.list(this, change_page);
            },
            exportExcel: function() {
                this.$base.exportExcel(this);
            },
            openAdd:function (op,vendor_id) {
                this.$base.linkTo("/base/orgvendor/save",{op: op,'vendor_id':vendor_id});
            },
            openSave:function (op, org_vendor_id) {
                this.$base.linkTo("/base/orgvendor/save",{op,'org_vendor_id':org_vendor_id});
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.getUnVendor();
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/base/orgvendor/list.vue